module.exports = __webpack_public_path__ + "img/message_history.8e92875b.svg";